<div class="notification-modal">
  <div class="notification-modal__backdrop"></div>
  <div class="notification-modal-container">
    <div class="notification-modal-container__content">
      <div class="notification-modal-container__content-text">{{modalInfo.text}}</div>
    </div>
    <div class="notification-modal-container__spinner" *ngIf="withSpinner">
      <app-spinner></app-spinner>
    </div>
    <div class="notification-modal-container__footer" *ngIf="!withSpinner">
      <button class="notification-modal-container__footer-button" (click)="modalInfo.isNeedCancelingButton ? submitModal() : closeModal()">
        {{modalInfo.submitButtonText}}
      </button>
      <button class="notification-modal-container__footer-button" *ngIf="modalInfo.isNeedCancelingButton" (click)="closeModal()">
        {{modalInfo.cancelButtonText}}
      </button>
    </div>
  </div>
</div>
